import { render, staticRenderFns } from "./HairdressingManager.vue?vue&type=template&id=2ce60f39&scoped=true&"
import script from "./HairdressingManager.vue?vue&type=script&lang=js&"
export * from "./HairdressingManager.vue?vue&type=script&lang=js&"
import style0 from "./HairdressingManager.vue?vue&type=style&index=0&id=2ce60f39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce60f39",
  null
  
)

export default component.exports